import { VirtualMirrorCatalogue } from '@luxottica/virtual-mirror'

const substractEans = (holders) => {
  return [...holders].map((holder) => holder.dataset['ean'])
}

const VMCatalogue = VirtualMirrorCatalogue.build({
  key: '92f28486-6ca0-46cf-9b66-fec8224ddc72',
})

export const extractEans = async (holders, updateEansFc) => {
  const eans = substractEans(holders)
  const result = VMCatalogue.isUpcSupported(...eans)

  let eanArray = []

  await Promise.all(
    eans.map(
      async (ean) =>
        await result[ean].then((response) => {
          eanArray.push({
            ean: response.getUpc(),
            isAvailable: response.isAvailable(),
          })
        })
    )
  )
  updateEansFc(eanArray)

  return eanArray
}
